<template>
    <select
      class="w-100 small"
      :disabled="isDisabled"
      @change="$emit('change', $event.target.value)">
      <slot />
    </select>
</template>

<script>
export default {
  props: {
    isDisabled: {
      type: Boolean
    }
  }
}
</script>

<style lang="sass">
select.small
  background-color: $paper
  border: 2px solid $paper
  color: $ink-dark
  height: 30px
  padding-left: 10px
  border-radius: 3px
  transition: all .15s ease-out
  font-size: 14px
  &::placeholder
    color: $ink-dark
    font-size: 12px
  &:hover
    background-color: $paper-dark
    border: 2px solid $paper-dark
  &:active
    background-color: $ink-dark
    color: white
    border: 2px solid $sensual
  &:focus
    background-color: transparent
    color: white
    border: 2px solid $sensual
  option
    background: $ink-dark
    color: $paper-lighter
</style>



// WEBPACK FOOTER //
// DashboardFilter.vue?8046ed88